import Notifications from '../../TenantPages/Notifications';

export default function SuperadminNotifications() {
  return <Notifications superadmin />;
}
